export default "__VITE_ASSET__BPHFNEPF__"